import axiosInstance from "../config/AxiosConfig";

export const productRepository = {
  findLatest: async (page) => {
    return await axiosInstance.get(`/products/flag/latest?page=${page}`);
  },
  findById: async (id) => {
    return await axiosInstance.get(`/products/${id}`);
  },
  findByNByCategory: async (categoryId, N) => {
    return await axiosInstance.get(
      `/products/category/${categoryId}/limit/${N}`,
    );
  },
  findByFlag: async (flag, page) => {
    return await axiosInstance.get(`/products/flag/${flag}?page=${page}`);
  },
  search: async (query, page) => {
    return await axiosInstance.post(`/products/search?page=${page}`, query);
  },
  getSales: async () => {
    return await axiosInstance.get(`/products/analytics/sales`);
  },
  getProductCount: async () => {
    return await axiosInstance.get(`/products/analytics/count`);
  },
  delete: async (productId) => {
    return await axiosInstance.delete(`/products/${productId}`);
  },
  create: async (details) => {
    return await axiosInstance.post(`/products`, details, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 180000,
    });
  },
  update: async (id, details) => {
    return await axiosInstance.put(`/products/${id}`, details, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 180000,
    });
  },
};
